export enum AnomalyDetailsProperties {
  granularity = 'granularity',
  lastPrediction = 'lastPrediction',
  alertTime = 'alertTime',
  duration = 'duration',
  feedback = 'feedback',
  image = 'image',
  endTime = 'endTime',
}

export class AnomalyDetails {
  [AnomalyDetailsProperties.granularity]: number;

  [AnomalyDetailsProperties.lastPrediction]: string;

  [AnomalyDetailsProperties.alertTime]: string;

  [AnomalyDetailsProperties.duration]: number;

  [AnomalyDetailsProperties.feedback]: AnomalyFeedback;

  [AnomalyDetailsProperties.image]: string;
}

export class Anomaly extends AnomalyDetails {
  [AnomalyDetailsProperties.endTime]: string = null;

  id: string;

  businessStructure: string;

  severity: AnomalySeverity;

  startTime: string;

  projectName: string;
}

export class AnomalyFeedback {
  comment: string;

  feedbackType: AnomalyFeedbackType;
}

export enum AnomalyFeedbackType {
  REAL_ANOMALY_WITH_IMPACT = 'REAL_ANOMALY_WITH_IMPACT',
  REAL_ANOMALY = 'REAL_ANOMALY',
  NOT_AN_ANOMALY = 'NOT_AN_ANOMALY',
  EVALUATE_LATER = 'EVALUATE_LATER',
}

export enum AnomalySeverity {
  CRITICAL = 'CRITICAL',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  WARNING = 'WARNING ',
  NORMAL = 'NORMAL',
}

export class AnomalyFilter {
  startTime?: string = null;

  endTime?: string = null;

  businessStructure?: string = null;

  severity?: AnomalySeverity = null;

  feedback?: AnomalyFeedbackType = null;

  businessUnit: string = null;
}
